import { Colors } from '@surglogs-app/ui.theme'

import { ColorVariants } from './VariantService'

export const ButtonVariants = [...ColorVariants, 'transparent'] as const
export type ButtonVariant = typeof ButtonVariants[number]

export const ButtonSizes = ['default', 'mini'] as const
export type ButtonSize = typeof ButtonSizes[number]

export const ButtonShapes = ['default', 'square', 'rounded'] as const
export type ButtonShape = typeof ButtonShapes[number]

type ColorScheme = {
  background: Colors
  color: Colors
  border: Colors
}

export const ButtonColors: Record<
  ButtonVariant,
  { base: ColorScheme; hover: ColorScheme }
> = {
  danger: {
    base: {
      background: 'red.100',
      color: 'white.100',
      border: 'red.100',
    },
    hover: {
      background: 'red.75',
      color: 'white.100',
      border: 'red.75',
    },
  },
  primary: {
    base: {
      background: 'blue.100',
      color: 'white.100',
      border: 'blue.100',
    },
    hover: {
      background: 'blue.75',
      color: 'white.100',
      border: 'blue.75',
    },
  },
  success: {
    base: {
      background: 'green.100',
      color: 'white.100',
      border: 'green.100',
    },
    hover: {
      background: 'green.75',
      color: 'white.100',
      border: 'green.75',
    },
  },
  warning: {
    base: {
      background: 'orange.100',
      color: 'white.100',
      border: 'orange.100',
    },
    hover: {
      background: 'orange.75',
      color: 'white.100',
      border: 'orange.75',
    },
  },
  default: {
    base: {
      background: 'navy.100',
      color: 'white.100',
      border: 'navy.100',
    },
    hover: {
      background: 'navy.75',
      color: 'white.100',
      border: 'navy.75',
    },
  },
  secondary: {
    base: {
      background: 'white.100',
      color: 'navy.100',
      border: 'navy.25',
    },
    hover: {
      background: 'white.100',
      color: 'blue.100',
      border: 'blue.100',
    },
  },
  transparent: {
    base: {
      background: 'transparent',
      color: 'navy.100',
      border: 'navy.25',
    },
    hover: {
      background: 'transparent',
      color: 'blue.100',
      border: 'blue.100',
    },
  },
}
